import React from "react";
import ReactDOM from "react-dom/client";
import { Providers } from "./app/providers";
import { AppRouter } from "./app/router";
import { registerTileCache } from "./lib/tileCache";
import { DevIdentityBadge } from "./components/dev/DevIdentityBadge";
// Core design system (order matters: variables → reset → layout → components)
import "./styles/variables.css";
import "./styles/reset.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/buttons.css";
import "./styles/modals.css";
// Feature CSS extracted from App.css — loaded globally since many components
// relied on App.css being global. Will migrate to component-level imports later.
import "./features/bores/components/BoreDashboard.css";
import "./features/bores/components/BoreItemSelectModal.css";
import "./features/bores/components/Bores.css";
import "./features/bores/components/DraggableCards.css";
import "./features/bores/components/JobsCard.css";
import "./components/maps/BoreMap.css";
import "./features/anti-collision/components/InterferenceModal.css";
import "./features/reports/forms/shared/report-forms-shared.css";
import "./App.css";
import "./styles/recoveredPhase6.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Providers>
      <AppRouter />
      {/* Dev only — says which worktree/branch/origin this is, and resets it. Compiles out
          of a production build via import.meta.env.DEV. */}
      <DevIdentityBadge />
    </Providers>
  </React.StrictMode>,
);

// Basemap tiles cached on OUR retention schedule, not the provider's — MapTiler's header
// is max-age=28800 (8 hours) where CARTO's was 15552000 (180 days), so without this the
// first look at a map each day re-fetches the whole viewport. Never throws; see
// lib/tileCache.ts.
registerTileCache();
